import { render } from "./notification-list-page.vue?vue&type=template&id=48b26c60&scoped=true"
import script from "./notification-list-page.vue?vue&type=script&lang=js"
export * from "./notification-list-page.vue?vue&type=script&lang=js"

import "./notification-list-page.vue?vue&type=style&index=0&id=48b26c60&scoped=true&lang=css"

import exportComponent from "/Users/apple/Documents/Full Stack Projects/elghoneimy-service-fullstack/source/admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48b26c60"]])

export default __exports__